import styled from 'styled-components'

export const ButtonSendStyle = styled.div<{ buttonColor: string; widthButton: string }>`
  width: ${({ widthButton }) => widthButton};
  margin: 0 2px;
  button {
    margin: 15px 0;
    width: 100%;
    padding: 5px 0;
    color: ${({ theme, buttonColor }) => {
      switch (buttonColor) {
        case 'normal':
          return theme.colors.white
        case 'success':
          return theme.colors.white
        case 'error':
          return theme.colors.white
        case 'alert':
          return theme.colors.black
        default:
          return theme.colors.white
      }
    }};
    font-family: inherit;
    font-size: ${({ theme }) => theme.fonts.size.normal};
    font-weight: ${({ theme }) => theme.fonts.weight.thin};
    background-color: ${({ theme, buttonColor }) => {
      switch (buttonColor) {
        case 'normal':
          return theme.colors.normal
        case 'success':
          return theme.colors.success
        case 'error':
          return theme.colors.error
        case 'alert':
          return theme.colors.alert
        default:
          return theme.colors.normal
      }
    }};
    border: none;
    border-radius: ${({ theme }) => theme.borderRadius.small};
    cursor: pointer;
    transition: background-color 200ms ease-in-out;
    &:hover {
      background-color: ${({ theme, buttonColor }) => {
        switch (buttonColor) {
          case 'normal':
            return theme.colors.darkNormal
          case 'success':
            return theme.colors.darkSuccess
          case 'error':
            return theme.colors.darkError
          case 'alert':
            return theme.colors.darkAlert
          default:
            return theme.colors.darkNormal
        }
      }};
    }
    &:disabled {
      background-color: ${({ theme }) => theme.colors.border};
      cursor: not-allowed;
    }
  }

  @media screen and (max-width: 720px) {
    button {
      font-size: ${({ theme }) => theme.fonts.size.small};
    }
  }

  @media screen and (max-width: 480px) {
    width: 100%;
  }
`
